exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-actions[data-v-077fa42a] {\n    min-width: 100px;\n}\n", ""]);

// exports
